import { useEffect, useRef, useState } from 'react';
import { getShippingRules } from '../api/get-shipping-rules';
export const useShippingRules = (props) => {
    const { country, product, quantity, productVariant } = props;
    const [shippingRules, setShippingRules] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const abortControllerRef = useRef();
    useEffect(() => {
        if (!country)
            return;
        const fetchData = async () => {
            abortControllerRef.current = new AbortController();
            setIsLoading(true);
            try {
                const { shippingServices } = await getShippingRules({
                    country,
                    product,
                    quantity,
                    productVariant,
                }, abortControllerRef.current?.signal);
                setShippingRules(shippingServices);
            }
            catch (e) {
                setShippingRules([]);
            }
            finally {
                setIsLoading(false);
            }
        };
        if (abortControllerRef.current?.signal) {
            abortControllerRef.current.abort('new_request_sent');
        }
        fetchData();
    }, [country, product, productVariant, quantity]);
    return {
        shippingRules,
        isLoading,
    };
};
